import { render, staticRenderFns } from "./IconOrSvg.vue?vue&type=template&id=0e249d0f&scoped=true&"
import script from "./IconOrSvg.vue?vue&type=script&lang=js&"
export * from "./IconOrSvg.vue?vue&type=script&lang=js&"
import style0 from "./IconOrSvg.vue?vue&type=style&index=0&id=0e249d0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e249d0f",
  null
  
)

export default component.exports